import Banner from '../API/banner';
import Category from './category';
import Testimonial from './testimonial';
import FAQ from './faq';

/* Exporting all Functions for reuseing in differnt components */
const api_collection = {
  Banner,
  Category,
  Testimonial,
  FAQ,
};
export default api_collection;